// 用户相关类型定义
// 用户状态枚举
export var UserStatus;
(function (UserStatus) {
    UserStatus[UserStatus["ACTIVE"] = 1] = "ACTIVE";
    UserStatus[UserStatus["INACTIVE"] = 0] = "INACTIVE";
    UserStatus[UserStatus["SUSPENDED"] = -1] = "SUSPENDED";
})(UserStatus || (UserStatus = {}));
// 用户类型枚举
export var UserType;
(function (UserType) {
    UserType["ADMIN"] = "admin";
    UserType["CUSTOMER"] = "customer";
    UserType["DRIVER"] = "driver";
    UserType["OPERATOR"] = "operator";
})(UserType || (UserType = {}));
//# sourceMappingURL=user.js.map